<template>
  <div>
    <template v-if="checkPayBy === null">
      <div style="position: relative">
        <h3 class="mt-5 text-center">{{ $t('Package') }}</h3>
        <v-card class="mt-2 py-2 px-4" style="line-height: 1.5rem">
          <p>{{ $t('purchase_package.purchase_detail') }}</p>
          <div class="ml-2 d-flex" style="font-size: medium">
            <span>
              {{ $t(this.value.service) }}
              {{ this.value.action.amount }}
              {{ $t('pieces') }}
            </span>
            <span class="ml-auto"> 1,999 {{ $t('฿') }} </span>
          </div>
          <div class="ml-2 d-flex" style="font-size: medium">
            <span>{{ $t('purchase_package.total_price') }}</span>
            <span class="ml-auto">
              {{ totalPrice.toLocaleString() }} {{ $t('฿') }}
            </span>
          </div>
          <div class="ml-2 d-flex" style="font-size: medium">
            <span>{{ $t('purchase_package.discount') }}</span>
            <span class="ml-auto">
              {{ (useCoin / 10).toLocaleString() }} {{ $t('฿') }}
            </span>
          </div>
          <div>
            <v-divider class="my-2" />
            <div class="d-flex">
              <span>{{ $t('purchase_package.total_amount') }}</span>
              <span class="ml-auto">
                {{ (totalPrice - useCoin / 10).toLocaleString() }} {{ $t('฿') }}
              </span>
            </div>
          </div>
        </v-card>

        <div class="mt-5 d-flex">
          <div>
            <h5>{{ $t(`purchase_package.discount`) }}</h5>
            <div style="font-size: small; line-height: 1.5rem">
              {{ $t('purchase_package.use_coin_as_discount') }}
            </div>
            <div style="font-size: x-small; line-height: 1.5rem">
              {{ $t('purchase_package.coin_condition') }}
            </div>
          </div>
          <div class="ml-auto d-flex">
            <div>
              <v-text-field
                v-model="useCoin"
                :label="$t('purchase_package.coin_used')"
                ref="useCoinRef"
                :append-outer-icon="useCoin ? 'mdi-close' : ''"
                @click:append-outer="clearUseCoin"
                @mousedown.prevent
                @wheel="blurOnWheel"
                @keydown="preventInputNoneBasicNumberAndDot"
                @input="handleInput"
                hide-details
                dense
                outlined
                class="coin-input"
              />
              <span style="font-size: small">
                {{
                  $t('purchase_package.your_coin', {
                    field: zCoin
                  })
                }}
              </span>
            </div>
            <v-btn class="w45 ml-2 btn-custom" @click="useAllCoin">{{
              $t('purchase_package.use_all_coin')
            }}</v-btn>
          </div>
        </div>

        <hr class="mt-5" />
        <h5 class="mt-5">{{ $t(`Payment channel`) }}</h5>
        <v-btn-toggle
          v-model="selectedPayment"
          mandatory
          class="d-flex mt-2"
          color="primary"
        >
          <v-btn
            v-for="option in paymentOptions"
            :key="option.value"
            :value="option.value"
            class="payment-btn"
            elevation="2"
            rounded
            depressed
            :disabled="
              totalPrice - useCoin / 10 === 0 && option.value === '2C2P'
            "
          >
            <div style="flex-direction: column !important">
              <v-icon size="32">{{ option.icon }}</v-icon>
              <div class="ml-2 mt-2 text-white" style="white-space: pre-line">
                {{ option.label }}
              </div>
            </div>
          </v-btn>
        </v-btn-toggle>
        <p class="caption mt-2" style="color: grey">
          {{ $t('purchase_package.credit_debit_card_remark') }}&nbsp;
          <a :href="isMobileDevice ? 'https://line.me/R/oaMessage/@989nlfws/?contactusrichmenu' : 'https://lin.ee/AAcfS3r'" target="_blank" style="color: var(--v-primary-base)">
            {{ $t('purchase_package.credit_debit_card_click_here') }}
          </a>
        </p>
        <v-btn
          outlined
          class="btn-custom mt-5"
          height="46"
          width="100%"
          @click="handlePay"
        >
          {{ $t('purchase_package.pay') }} ({{
            (totalPrice - useCoin / 10).toLocaleString()
          }}
          {{ $t('฿') }})
        </v-btn>

        <template>
          <v-dialog v-model="qrDialog" persistent max-width="600px">
            <v-card>
              <div
                class="pointer"
                style="float: right; margin-right: 10px; margin-top: 10px"
              >
                <v-icon @click="closeQrDialog">mdi-close</v-icon>
              </div>
              <v-card-title
                style="
                  place-content: center;
                  display: block;
                  text-align: -webkit-center;
                  font-size: medium;
                "
              >
                <span>
                  {{ $t('purchase_package.please_pay_in') }}
                </span>
                <span style="color: var(--error-color)">
                  {{ secondsToReadableTime(countDown) }}
                </span>
                <br />
                <span>
                  {{ $t('purchase_package.payment_warning_close_window') }}
                </span>
                <v-card outlined class="mt-5 mb-5 color-white">
                  <qr-code
                    class="mt-5 mb-5"
                    :text="qrCode"
                    :size="250"
                    color="#000000"
                    bg-color="#ffffff"
                    error-level="L"
                  ></qr-code
                ></v-card>
                <v-btn
                  @click="handleConfirmPayment"
                  width="100%"
                  class="btn-custom mt-5 mb-5"
                >
                  {{ $t('purchase_package.confirm_payment') }}
                </v-btn>
                <span style="font-size: small">
                  {{ $t('purchase_package.info_confirm_payment_button') }}
                </span>
              </v-card-title>
            </v-card>
          </v-dialog>
        </template>

        <!-- <div class="mt-5" style="text-align: -webkit-center">
          <v-row>
            <v-col cols="12" sm="6">
              <v-dialog v-model="qrDialog" persistent max-width="400px">
                <template #activator="{ on, attrs }">
                  <v-btn
                    outlined
                    class="btn-custom mr-2"
                    height="46"
                    width="100%"
                    v-bind="attrs"
                    @click="ActiveCreditCard('qr')"
                    v-on="on"
                  >
                    <v-icon
                      class="pr-2"
                      style="font-size: 30px; margin: 2px 3px 0px 0px"
                      >mdi-qrcode-scan</v-icon
                    >
                    <span>{{ $t('purchase_package.qr') }}</span>
                  </v-btn>
                </template>
                <v-card style="background: var(--v-primary-lighten2)">
                  <div
                    class="pointer"
                    style="float: right; margin-right: 10px; margin-top: 10px"
                  >
                    <v-icon color="#ffffff" @click="closeQrDialog"
                      >mdi-close</v-icon
                    >
                  </div>
                  <v-card-title
                    style="
                      place-content: center;
                      display: block;
                      text-align: -webkit-center;
                    "
                  >
                    <v-card outlined class="r0 mt-5 mb-5 color-white">
                      <qr-code
                        class="mt-5 mb-5"
                        :text="qrCode"
                        :size="200"
                        color="#000000"
                        bg-color="#ffffff"
                        error-level="L"
                      ></qr-code
                    ></v-card>
                    <h3 class="mt-3 mb-3 color-white">
                      <v-icon color="#ffffff">mdi-cellphone-screenshot </v-icon>
                      {{ $t('Scan me before') }}
                      {{ secondsToReadableTime(countDown) }}
                    </h3>
                  </v-card-title></v-card
                >
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="6" class="mt-0 mt-sm-0">
              <v-btn
                outlined
                class="btn-custom mr-2"
                height="46"
                width="100%"
                @click="checkPayBy = 'creditCard'"
              >
                <v-icon
                  class="pr-2"
                  style="font-size: 30px; margin: 2px 3px 0px 0px"
                >
                  mdi-credit-card-multiple
                </v-icon>
                <span>{{ $t('purchase_package.credit_debit_card') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </div> -->
      </div>
    </template>

    <template v-if="checkPayBy === 'creditCard'">
      <h3 class="mt-3" style="font-size: 115%">
        {{ $t('Your credit card') }}
      </h3>
      <v-card outlined class="mt-3 r0 pr-5 pl-5" style="border: none">
        <v-card-title style="padding: 16px 15px 10px">
          <v-row no-gutters>
            <v-col cols="12" md="6"> {{ $t('Manage credit card') }} </v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template #activator="{ on, attrs }">
                  <v-btn outlined class="btn-custom" v-bind="attrs" v-on="on">
                    <v-icon style="font-size: 15px; margin: 2px 3px 0px 0px">
                      mdi-plus
                      <!-- mdi-credit-card-plus-outline --> </v-icon
                    ><span class="ml-1">{{ $t('Add credit card') }}</span>
                  </v-btn>
                </template>
                <v-card>
                  <div class="pa-3">
                    <validation-observer ref="changePass" v-slot="{ invalid }">
                      <form @submit.prevent="addCreditCard">
                        <v-card-title>
                          <h3>{{ $t('Credit Card') }}</h3>
                        </v-card-title>
                        <v-card-text>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="$t('Name on card')"
                            :rules="{
                              required: true
                            }"
                          >
                            <v-text-field
                              v-model="creditCard.credit_card_name"
                              :label="$t('Name on card')"
                              :error-messages="errors"
                              outlined
                              dense
                              counter="250"
                              maxlength="250"
                              required
                            ></v-text-field>
                          </validation-provider>

                          <validation-provider
                            v-slot="{ errors }"
                            :name="$t('Card No.')"
                            :rules="{
                              required: true,
                              regex: /^[0-9]*$/
                            }"
                          >
                            <v-text-field
                              v-model="creditCard.credit_card_number"
                              :label="$t('Card No.')"
                              :error-messages="errors"
                              outlined
                              dense
                              counter="16"
                              maxlength="16"
                              required
                            ></v-text-field>
                          </validation-provider>

                          <v-row>
                            <v-col>
                              <validation-provider
                                v-slot="{ errors }"
                                :name="$t('Expiry Month')"
                                :rules="{
                                  required: true,
                                  regex: /^[0-9]*$/
                                }"
                              >
                                <v-text-field
                                  v-model="
                                    creditCard.credit_card_expiration_month
                                  "
                                  outlined
                                  dense
                                  counter="2"
                                  maxlength="2"
                                  :label="$t('Expiry Month')"
                                  :error-messages="errors"
                                  required
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                            <v-col>
                              <validation-provider
                                v-slot="{ errors }"
                                :name="$t('Expiry Year')"
                                :rules="{
                                  required: true,
                                  regex: /^[0-9]*$/
                                }"
                              >
                                <v-text-field
                                  v-model="
                                    creditCard.credit_card_expiration_year
                                  "
                                  outlined
                                  dense
                                  counter="2"
                                  maxlength="2"
                                  :label="$t('Expiry Year')"
                                  :error-messages="errors"
                                  required
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>
                          <validation-provider
                            v-slot="{ errors }"
                            name="CVV"
                            :rules="{
                              required: true,
                              regex: /^[0-9]*$/
                            }"
                          >
                            <v-text-field
                              v-model="creditCard.credit_card_security_code"
                              outlined
                              dense
                              counter="3"
                              maxlength="3"
                              label="CVV"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-card-text>
                        <v-card-actions
                          class="pb-6"
                          style="justify-content: center"
                        >
                          <v-btn
                            outlined
                            class="w45 br-7 btn-back-richmenu"
                            @click="dialog = false"
                            >{{ $t('Cancel') }}</v-btn
                          >
                          <v-btn
                            outlined
                            class="btn-custom w45 right"
                            :disabled="invalid"
                            type="submit"
                            ><span>{{ $t('Submit') }}</span>
                          </v-btn>
                        </v-card-actions>
                      </form>
                    </validation-observer>
                  </div>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <!-- <v-simple-table class="mt-6">
        <template v-slot:default>
          <tbody>
            <tr v-for="(item, i) in allCreditCard" :key="i">
              <td class="text-center"><v-icon style="font-size: 50px">mdi-credit-card</v-icon></td> -->
      <!-- <td>Master card</td> -->
      <!-- <td>{{ item.credit_card_name }}</td>
              <td>
                <h4>{{ item.credit_card_number }}</h4>
              </td>
              <td class="text-right">
                <v-btn
                  v-if="$route.name !== 'Account'"
                  @click="selectCard(item)"
                  outlined
                  class="btn-custom green mr-3 small-btn light-weight"
                  style="box-shadow: 10px 10px 10px #00000012"
                  >{{ $t("Select") }}</v-btn
                >
                <v-btn style="box-shadow: none" color="primary" fab x-small>
                  <v-icon @click="deleteCreditCard(item)">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table> -->
      <v-row v-for="(item, i) in allCreditCard" :key="i" class="ma-2 mt-1">
        <v-col cols="2" class="text-center">
          <!-- <v-icon style="font-size: 30px">mdi-credit-card</v-icon> -->
          <v-img
            src="/img/LineRichmenu/icons/creditcard.png"
            style="max-width: 50px; margin: auto"
          ></v-img>
        </v-col>
        <v-col cols="7" class="text-left">
          <v-row no-gutters>
            <v-col cols="12" md="6" lg="6">
              <h6 class="text-truncate mt-md-2">{{ item.credit_card_name }}</h6>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h6 class="mt-md-2">{{ item.credit_card_number }}</h6>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3" class="text-right">
          <v-btn
            v-if="$route.name !== 'Account'"
            outlined
            class="btn-custom green mr-3 small-btn light-weight"
            style="box-shadow: 10px 10px 10px #00000012"
            @click="selectCard(item)"
            >{{ $t('Select') }}</v-btn
          >
          <v-btn
            style="box-shadow: none"
            class="mt-1 mt-sm-0"
            color="primary"
            fab
            x-small
          >
            <v-icon @click="deleteCreditCard(item)">mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <form
      v-show="false"
      ref="gbchargeform"
      name="form"
      :action="`${gbPrimeUrl}v1/tokens/3d_secured`"
      method="POST"
      enctype="application/x-www-form-urlencoded"
    >
      publicKey:

      <input
        type="text"
        name="publicKey"
        :value="'CSAQoqa1weFgT7p9IENwQpqj1KdM7Wxd'"
      />
      <br />
      gbpReferenceNo:
      <input type="text" name="gbpReferenceNo" :value="gbpReferenceNo" />
      <v-btn v-if="false" type="submit">send</v-btn>
    </form>
  </div>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      dialog: false,
      creditCard: [],
      allCreditCard: [],
      gbpReferenceNo: '',
      qrDialog: false,
      qrCode: '',
      qrcodeInterval: null,
      counter: 0,
      expriedTime: 900,
      qrimage: null,
      startCountDown: 900,
      countDown: 0,
      timeOutCount: null,
      gbPrimeUrl: '',
      checkPayBy: null,
      totalPrice: 1999,
      zCoin: 0,
      useCoin: '',
      selectedPayment: '2C2P',
      paymentOptions: [
        /*{
          icon: 'mdi-qrcode-scan',
          label: this.$t('purchase_package.qr'),
          value: 'qr'
        },*/
        {
          icon: 'mdi-credit-card-multiple',
          label: this.$t('purchase_package.credit_debit_card'),
          value: '2C2P'
        }
      ],
      tid: '',
      email: ''
    }
  },
  created() {
    this.gbPrimeUrl = config.gbPrimeUrl
  },
  mounted() {
    this.getAccount()
    this.getCardByAccount()
    // creditCard
    if (this.$route.name == 'Account') {
      this.checkPayBy = 'creditCard'
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      clickTrial: 'lineRichmenuManager/getClickTrial',
      IdCreditCard: 'packagePlan/getIdCreditCard'
    }),
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  },
  beforeDestroy() {
    if (this.qrcodeInterval) {
      clearInterval(this.qrcodeInterval)
    }
  },
  methods: {
    async getAccount() {
      this.$store.dispatch('setOverlay', true)
      var res = await this.$store.dispatch('ssoAccount/getAccount')
      if (res) {
        this.$store.dispatch('setOverlay', false)
        this.zCoin = res.data.result.member_point.find(
          (p) => p.member_point_master.id === 'zcoin'
        ).quantity
        this.email = res.data.result.email
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    },

    async getCardByAccount() {
      var res = await this.$store.dispatch('packagePlan/getCardByAccount')
      if (res) {
        this.allCreditCard = res.data.data
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `something went wrong, please try again.`
        })
      }
    },

    async createCreditCard(creditCard) {
      var res = await this.$store.dispatch('packagePlan/createCreditCard', {
        credit_card_number: creditCard.credit_card_number, // 16 ตัวอักษร
        credit_card_name: creditCard.credit_card_name, // optional, 250 ตัวอักษร
        credit_card_expiration_month: creditCard.credit_card_expiration_month, // 2 ตัวอักษร
        credit_card_expiration_year: creditCard.credit_card_expiration_year, // 2 ตัวอักษร
        credit_card_security_code: creditCard.credit_card_security_code, // 3 ตัวอักษร
        active: false // optional
      })
      if (res) {
        this.getCardByAccount()
        this.dialog = false
        this.$notify({
          group: 'foo',
          type: 'success',
          title: 'Success',
          text: `${creditCard.credit_card_number} has been save.`
        })
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `something went wrong, please try again.`
        })
      }
    },

    selectCard(item) {
      this.ActiveCreditCard('credit')
      this.$store.dispatch('packagePlan/selectCreditCardId', item.id)
    },

    addCreditCard() {
      this.createCreditCard(this.creditCard)
    },

    async deleteCreditCard(item) {
      this.$confirm(
        `${this.$t('you want to delete')} ${item.credit_card_number} ?`,
        this.$t('Are you sure?'),
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(async () => {
          var res = await this.$store.dispatch('packagePlan/deleteCreditCard', {
            credit_card_id: item.id
          })
          if (res) {
            this.getCardByAccount()
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success',
              text: `${item.credit_card_number} has been deleted.`
            })
            this.selectGroup(this.groupSelect)
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: `${item.credit_card_number} has not deleted.`
            })
          }
        })
        .catch(() => {
          // console.log("OK not selected.");
        })
    },

    countDownTimer() {
      clearTimeout(this.timeOutCount)
      if (this.countDown > 0) {
        this.timeOutCount = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    async ActiveCreditCard(typePay) {
      this.$nextTick(async () => {
        this.value.payment.credit_card_id = this.IdCreditCard
        if (typePay === 'qr') {
          this.qrDialog = true
          this.value.payment.type = 'qr_code'
        } else {
          this.value.payment.type = 'credit_card'
          if (this.clickTrial) {
            this.value.action.response_url = `https://app.zwiz.ai/richmenu/maker?rmid=${this.$store.state.lineRichmenuManager.idTemplate}&step=8`
          } else {
            this.value.action.response_url = `https://app.zwiz.ai/richmenu`
          }
        }
        if (this.clickTrial) {
          this.value.action.trial_line_richmenu_id =
            this.$store.state.lineRichmenuManager.idTemplate
        }
        var res = await this.$store.dispatch(
          'packagePlan/servicePaid',
          this.value
        )
        if (res && res.data.data.resultCode == '00') {
          if (typePay === 'qr') {
            this.countDown = this.startCountDown
            this.qrCode = res.data.data.qrcode
            this.verifyGbTransaction(res.data.data.referenceNo)
            this.countDownTimer()
          } else {
            this.gbpReferenceNo = res.data.data.gbpReferenceNo
            this.$nextTick(() => {
              this.$refs.gbchargeform.submit()
            })
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `something went wrong, please try again.`
          })
        }
      })
    },

    closeQrDialog() {
      this.qrDialog = false
      clearInterval(this.qrcodeInterval)
    },

    async verifyGbTransaction(referenceNo) {
      var vm = this
      this.expriedTime = 900
      this.counter = 0
      this.qrcodeInterval = setInterval(async () => {
        var res = await this.$store.dispatch(
          'packagePlan/verifyGbTransaction',
          {
            referenceNo: referenceNo
          }
        )
        if (vm.countDown === 0) {
          clearInterval(this.qrcodeInterval)
          this.$alert(
            `โปรดชำระเงินในเวลาที่กำหนด.`,
            this.$t('Error'),
            'error'
          ).then(() => (vm.qrDialog = false))
        }
        if (res.data.result.status === 'G' || res.data.result.status === 'A') {
          this.counter++
        } else if (res.data.result.status === 'S') {
          clearInterval(vm.qrcodeInterval)
          this.$alert(
            'ท่านทำการชำระเงินเรียบร้อยแล้ว ระบบจะนำท่านไปที่หน้ารวมริชเมนู',
            'สำเร็จ',
            'success'
          ).then(() => {
            vm.qrDialog = false
            vm.$emit('closeDialog')
            const path = `/${this.currentLang}/richmenu`
            const pathMaker = `/${this.currentLang}/maker`
            if (vm.clickTrial) {
              let r = vm.$router.resolve({
                path: pathMaker,
                query: {
                  rmid: vm.$store.state.lineRichmenuManager.idTemplate,
                  step: 8
                }
              })
              window.location.assign(r.href)
            } else if (vm.$route.path !== path) {
              // let query = {
              //   line_richmenu_package_id: vm.value.action.line_richmenu_package_id || null,
              // };
              vm.$router.push({
                path
                // query: query,
                // shallow: true,
              })
              location.reload()
            }
          })
        } else {
          this.$alert(
            `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง`,
            this.$t('Error'),
            'error'
          ).then(() => (vm.qrDialog = false))
        }
      }, 5000)
    },
    secondsToReadableTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60

      return `${minutes} ${this.$t('minutes')} ${remainingSeconds} ${this.$t(
        'seconds'
      )}`
    },

    async handlePay() {
      var formattedValue = {
        items: [
          {
            item_name: this.value.service,
            item_quantity: this.value.action.amount
          }
        ],
        payment_method: this.selectedPayment,
        redeem_options: this.useCoin
          ? [
              {
                id: 'zcoin',
                quantity: this.useCoin
              }
            ]
          : undefined,
        source: 'richmenu',
        return_url:
          this.selectedPayment === '2C2P'
            ? `${config.serverUrl}api/callback/redirect`
            : ''
      }

      const response = await this.$store.dispatch(
        'packagePlan/purchasePackage',
        formattedValue
      )
      const responseData = response.data || response.response?.data
      if (responseData && responseData.success === false) {
        let messages = responseData.message || []
        if (typeof messages === 'string') {
          messages = [messages]
        }
        const translatedMessage =
          messages.length > 0
            ? messages.map((m) => this.$t(m)).join(', ')
            : this.$t('something_went_wrong')
        this.$alert(translatedMessage, this.$t('Error'), 'error').then(() => {
          // console.log("Closed")
        })
        return
      }
      const { result } = responseData || {}
      if (!result) {
        this.$alert(
          this.$t('something_went_wrong'),
          this.$t('Error'),
          'error'
        ).then(() => {
          // console.log("Closed")
        })
        return
      }
      if (result.payment_method === 'qr' && result.payment_response_data) {
        this.qrDialog = true
        this.countDown = this.startCountDown
        this.qrCode = result.payment_response_data.qr.raw_data
        this.tid = result.tid
        this.countDownTimer()
      } else if (
        result.payment_method === '2C2P' &&
        result.payment_2c2p_data?.payment_2c2p_payment_link
      ) {
        const url = new URL(result.payment_2c2p_data.payment_2c2p_payment_link)

        window.location = url.href
      } else if (
        result.payment_method === 'zcoin' &&
        result.redeem_response_data &&
        result.transaction_status === 'success'
      ) {
        const isSuccess = result.transaction_status === 'success'
        let res = await this.$fire({
          title: isSuccess
            ? this.$t('purchase_package.payment_success_coin')
            : this.$t(result.transaction_status),
          text: isSuccess
            ? this.$t('purchase_package.remaining_coin', {
                field: result.redeem_response_data?.result.new_member_point
              })
            : '',
          type: isSuccess ? 'success' : 'error'
        })
        if (res.value) {
          if (isSuccess) {
            this.zCoin = String(
              result.redeem_response_data?.result.new_member_point
            )
            window.location.reload()
          }
        }
      }
    },

    async handleConfirmPayment() {
      var response = await this.$store.dispatch(
        'packagePlan/verifyPurchasePackage',
        { tid: this.tid }
      )
      if (response) {
        const isSuccess = response.data.result.transaction_status === 'success'
        const zcoinRedeem = response.data.result.redeem_options.find(
          (redeem) => redeem.id === 'zcoin'
        )
        const redeemNotEnough =
          response.data.result.redeem_point_not_enough || []
        const zcoinNotEnough = redeemNotEnough.find(
          (redeem) => redeem.id === 'zcoin'
        )
        if (redeemNotEnough.length > 0 && zcoinNotEnough) {
          this.$fire({
            title: this.$t('purchase_package.coin_not_enough_please_contact'),
            type: 'error',
            reverseButtons: true,
            showCancelButton: false,
            confirmButtonText: this.$t('purchase_package.contact_admin')
          }).then(() => {
            window.open(
              `https://m.me/361231620965547?ref=การชำระเงินซื้อแพ็กเกจ RICHMENU (${this.email})`
            )
            this.closeQrDialog()
          })
        } else {
          await this.$fire({
            title: isSuccess
              ? this.$t('purchase_package.payment_success')
              : this.$t(
                  response.data.result.transaction_status === 'pending'
                    ? `purchase_package.${response.data.result.transaction_status}_payment`
                    : response.data.result.transaction_status
                ),
            text:
              isSuccess && zcoinRedeem
                ? this.$t('purchase_package.remaining_coin', {
                    field:
                      (Number(this.zCoin) || 0) - (zcoinRedeem?.quantity || 0)
                  })
                : '',
            type: isSuccess ? 'success' : 'error',
            reverseButtons: true,
            showCancelButton: false,
            confirmButtonText: this.$t('OK')
          }).then(() => {
            if (isSuccess) {
              window.location.reload()
            }
          })
        }
      }
    },

    blurOnWheel(e) {
      e.target.blur()
    },
    preventInputNoneBasicNumberAndDot(e) {
      const allowed = [
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        '.',
        '-'
      ]
      if (!/^\d$/.test(e.key) && !allowed.includes(e.key)) {
        e.preventDefault()
      }
    },
    handleInput(value) {
      const tempNumber = Number(value)
      const maxPayCal = this.totalPrice * 10
      if (tempNumber <= maxPayCal) {
        if (tempNumber <= this.zCoin) {
          const coin = tempNumber < 0 ? '' : tempNumber || value
          const stringCoin = isNaN(tempNumber) ? value : String(coin)
          this.useCoin = stringCoin
          this.$refs.useCoinRef.lazyValue = stringCoin
        } else {
          const stringZcoin = String(this.zCoin)
          this.useCoin = stringZcoin
          this.$refs.useCoinRef.lazyValue = stringZcoin
        }
      } else {
        if (tempNumber > maxPayCal) {
          const stringCoin = String(maxPayCal)
          this.useCoin = stringCoin
          this.$refs.useCoinRef.lazyValue = stringCoin
        } else {
          const stringZcoin = String(this.zCoin)
          this.useCoin = stringZcoin
          this.$refs.useCoinRef.lazyValue = stringZcoin
        }
      }
    },
    clearUseCoin() {
      this.useCoin = ''
    },
    useAllCoin() {
      const needCoin = this.totalPrice * 10
      const coin = this.zCoin > needCoin ? needCoin : this.zCoin
      const stringCoin = String(coin)
      this.useCoin = stringCoin

      if (this.$refs.useCoinRef) {
        this.$refs.useCoinRef.lazyValue = stringCoin
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.theme--light.v-data-table {
  background: none;
}
td {
  border-bottom: none !important;
}
.green {
  background: #00ba07;
}
.gray {
  background: #b5b5b5;
}
</style>
